var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expandable",class:{
    'expandable--expanded': _vm.expanded,
  }},[_c('div',{staticClass:"expandable__header",class:{
      'expandable__header--card': _vm.card,
      'expandable--toggle-on-click': _vm.toggleOnClick,
    },on:{"click":function($event){_vm.toggleOnClick && _vm.toggle()}}},[_vm._t("header",null,{"toggle":_vm.toggle,"expanded":_vm.expanded})],2),_vm._v(" "),(_vm.expanded)?_c('div',{staticClass:"expandable__content",class:{ 'expandable__content--card': _vm.card }},[_vm._t("default",null,{"toggle":_vm.toggle,"expanded":_vm.expanded})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }